export const companyBrandingState = {
    errorCode : 0,
    statusCode : 0,
    brandList:[],
    passwordData:{},
    Message : '',
    isLoading : false,
    
}